import { Card, compareRank, compareSuit, getRankValue, Rank } from '../game-lib';
export function countDeadwood(hand, ignore11th = false) {
    const collection = getCollection(hand);
    let count = 0;
    for (const card of collection.deadwood) {
        count += getPointValue(card.rank);
    }
    //minus 11th card, the highest value card in the deadwood
    if (ignore11th && hand.length > 10) {
        let highestPointsCard = 0;
        for (const card of collection.deadwood) {
            const points = getPointValue(card.rank);
            if (highestPointsCard < points) {
                highestPointsCard = points;
            }
        }
        count -= highestPointsCard;
    }
    return count;
}
export function getPointValue(rank) {
    switch (rank) {
        case 'A':
            return 1;
        case 'K':
            return 10;
        case 'Q':
            return 10;
        case 'J':
            return 10;
        default:
            const val = parseInt(rank);
            return val;
    }
}
function findAllRuns(hand, index, runs, run = []) {
    //assumption: hand is sorted by rank and suit
    if (index >= hand.length) {
        return;
    }
    //seed the run
    if (run.length === 0) {
        run.push(hand[index]);
        findAllRuns(hand, index + 1, runs, run);
        return;
    }
    const runLastCard = run[run.length - 1];
    for (let i = index; i < hand.length; i++) {
        const nextHandCard = hand[i];
        const nextHandCardValue = getRankValue(nextHandCard.rank);
        const runLastCardValue = getRankValue(runLastCard.rank);
        if (runLastCardValue + 1 === nextHandCardValue && runLastCard.suit === nextHandCard.suit) {
            //we have a run
            const runCopy = Array.from(run);
            runCopy.push(nextHandCard);
            //add run if larger 3 or larger
            if (runCopy.length >= 3) {
                runs.push(runCopy);
            }
            //look for longer runs
            findAllRuns(hand, i + 1, runs, runCopy);
        }
        if (runLastCardValue + 1 < nextHandCardValue) {
            break;
        }
    }
}
export function getCollection(cards) {
    const handCopy = cards.map((c) => Card.fromString(`${c.rank}${c.suit}`)).sort(rankAndSuitSorter);
    const possibleMelds = [];
    //find all possible sets
    const ranks = Object.values(Rank);
    for (const rank of ranks) {
        const sameSuits = handCopy.filter((m) => m.rank === rank);
        if (sameSuits.length < 3) {
            continue;
        }
        if (sameSuits.length === 3) {
            possibleMelds.push(sameSuits);
        }
        if (sameSuits.length === 4) {
            //find all sets of 3 and the 1 set of 4
            possibleMelds.push([sameSuits[0], sameSuits[1], sameSuits[2]]);
            possibleMelds.push([sameSuits[0], sameSuits[1], sameSuits[3]]);
            possibleMelds.push([sameSuits[0], sameSuits[2], sameSuits[3]]);
            possibleMelds.push([sameSuits[1], sameSuits[2], sameSuits[3]]);
            possibleMelds.push([sameSuits[0], sameSuits[1], sameSuits[2], sameSuits[3]]);
        }
    }
    //find all possible runs
    for (let i = 0; i < handCopy.length; i++) {
        findAllRuns(handCopy, i, possibleMelds);
    }
    //find all compatible melds
    const compatibleMelds = [];
    //3 melds is the max a hand can have
    for (const meld1 of possibleMelds) {
        const cleanMelds = possibleMelds.filter((m) => m.every((c) => !meld1.includes(c)));
        if (cleanMelds.length === 0) {
            compatibleMelds.push([meld1]);
            continue;
        }
        for (const meld2 of cleanMelds) {
            const cleanMelds2 = cleanMelds.filter((m) => m.every((c) => !meld1.includes(c) && !meld2.includes(c)));
            if (cleanMelds2.length === 0) {
                compatibleMelds.push([meld1, meld2]);
                continue;
            }
            for (const meld3 of cleanMelds2) {
                compatibleMelds.push([meld1, meld2, meld3]);
            }
        }
    }
    //find the best melds
    let bestMelds = [];
    let highestPoints = 0;
    let lowestMeldCount = 5;
    for (const melds of compatibleMelds) {
        //find highest points which inversely correlates to the lowest deadwood
        //get all the cards in the melds as a single array
        const meldCards = [].concat(...melds);
        //calculate points
        const points = meldCards.reduce((acc, val) => acc + getRankValue(val.rank), 0);
        if (points > highestPoints || (points === highestPoints && melds.length < lowestMeldCount)) {
            bestMelds = melds;
            highestPoints = points;
            lowestMeldCount = melds.length;
        }
    }
    //get dead wood using the best melds
    const meldCards = [].concat(...bestMelds);
    const deadwood = handCopy.filter((c) => !meldCards.includes(c));
    //split best melds into sets and runs
    const sets = [];
    const runs = [];
    for (const meld of bestMelds) {
        //if all cards are the same suit, it's a run
        const firstCard = meld[0];
        const allSameSuit = meld.every((c) => c.suit === firstCard.suit);
        if (allSameSuit) {
            runs.push(meld);
        }
        else {
            sets.push(meld);
        }
    }
    const collection = {
        sets: sets,
        runs: runs,
        deadwood: deadwood,
    };
    return collection;
}
export function getCollection2(cards) {
    //https://gist.github.com/yalue/2622575
    const collection = {
        sets: [],
        runs: [],
        deadwood: [],
    };
    const handCopy = cards.map((c) => Card.fromString(c.toString())).sort(rankAndSuitSorter);
    //find melds
    while (handCopy.length > 0) {
        const card1 = handCopy[handCopy.length - 1];
        const set = [card1];
        const run = [card1];
        for (let i = handCopy.length - 1; i >= 0; i--) {
            const card2 = handCopy[i];
            if (card1 === card2) {
                continue;
            }
            if (card1.rank === card2.rank) {
                set.push(card2);
            }
            if (card1.suit === card2.suit) {
                const nextMeldStriaghtCard = run[run.length - 1];
                const valueDiff = getRankValue(nextMeldStriaghtCard.rank) - getRankValue(card2.rank);
                if (valueDiff === 1) {
                    run.push(card2);
                }
            }
        }
        if (set.length < 3 && run.length < 3) {
            //remove card from start array
            handCopy.splice(handCopy.length - 1, 1);
            //add card to end array
            collection.deadwood.push(card1);
        }
        else {
            if (set.length > run.length) {
                //remove cards from start array
                //***not working */
                for (const setCard of set) {
                    const index = handCopy.findIndex(function (card) {
                        return card.id === setCard.id;
                    });
                    handCopy.splice(index, 1);
                }
                //add card to end array
                set.sort(rankAndSuitSorter);
                collection.sets.push(set);
            }
            else {
                //remove cards from start array
                //***not working */
                for (const runCard of run) {
                    const index = handCopy.findIndex(function (card) {
                        return card.id === runCard.id;
                    });
                    handCopy.splice(index, 1);
                }
                //add card to end array
                run.sort(rankAndSuitSorter);
                collection.runs.push(run);
            }
        }
    }
    collection.deadwood.sort(rankAndSuitSorter);
    return collection;
}
// export function getCollection(hand: Card[]): Collections {
// 	const collection: Collections = {
// 		sets: [],
// 		runs: [],
// 		deadwood: [],
// 	};
// 	const handCopy = hand.map((c) => Card.fromString(c.toString())).sort(sorter);
// 	//check for runs
// 	for (let x = 0; x < hand.length; ++x) {
// 		const card = handCopy[x];
// 		const currentRank = getRankValue(card.rank);
// 		const currentSuit = card.suit;
// 		//check for already existing run
// 		let shouldContinue = false;
// 		for (const run of collection.runs) {
// 			const firstCard = run[0];
// 			//one less than current lowest?
// 			if (currentRank + 1 === getRankValue(firstCard.rank) && currentSuit === firstCard.suit) {
// 				run.unshift(card);
// 				shouldContinue = true;
// 				break;
// 			}
// 			const lastCard = run[run.length - 1];
// 			//one more than current highest?
// 			if (lastCard && getRankValue(lastCard.rank) + 1 === currentRank && lastCard.suit === currentSuit) {
// 				run.push(card);
// 				shouldContinue = true;
// 				break;
// 			}
// 		}
// 		if (shouldContinue) {
// 			continue;
// 		}
// 		//Check for new run
// 		if (
// 			x < hand.length - 2 &&
// 			currentRank + 1 === getRankValue(handCopy[x + 1].rank) &&
// 			currentSuit === handCopy[x + 1].suit &&
// 			getRankValue(handCopy[x + 1].rank) + 1 === getRankValue(handCopy[x + 2].rank) &&
// 			currentSuit === handCopy[x + 2].suit
// 		) {
// 			//we have a run of card and the next two cards
// 			collection.runs.push([card, handCopy[x + 1], handCopy[x + 2]]);
// 			x += 2;
// 			continue;
// 		}
// 		//doesn't belong to any runs, let's check for sets
// 		for (const set of collection.sets) {
// 			const firstCard = set[0];
// 			if (getRankValue(firstCard.rank) === currentRank) {
// 				set.push(card);
// 				shouldContinue = true;
// 				break;
// 			}
// 		}
// 		if (shouldContinue) {
// 			continue;
// 		}
// 		//check for new set
// 		let cardsInRuns: string[] = [];
// 		for (const run of collection.runs) {
// 			//only count "middle cards" if the run is 4+ cards
// 			if (run.length >= 4) {
// 				const runValues = run.map((c) => c.toString());
// 				runValues.pop();
// 				runValues.shift(); //take the first and last card off
// 				cardsInRuns = cardsInRuns.concat(runValues);
// 				continue;
// 			}
// 			cardsInRuns = cardsInRuns.concat(run.map((c) => c.toString()));
// 		}
// 		//need to make sure that the items in the set don't already belong to a run
// 		const filtered = handCopy.filter((c) => getRankValue(c.rank) === currentRank && !cardsInRuns.includes(c.toString()));
// 		if (filtered.length >= 3) {
// 			collection.sets.push(handCopy.filter((c) => getRankValue(c.rank) === currentRank));
// 			continue;
// 		}
// 		//doesn't belong, it's deadwood
// 		collection.deadwood.push(card);
// 	}
// 	return collection;
// }
function sorter(l, r) {
    const result = compareSuit(l.suit, r.suit);
    if (result !== 0) {
        return result;
    }
    return compareRank(l.rank, r.rank);
}
function rankAndSuitSorter(l, r) {
    const result = compareRank(l.rank, r.rank);
    if (result !== 0) {
        return result;
    }
    return compareSuit(l.suit, r.suit);
}
function orderSorter(l, r) {
    const result = l.order - r.order;
    return result;
}
//this is an in-place sort
export function sortBySuitAndRank(cards) {
    cards.sort(sorter);
    updateCardOrder(cards);
    return cards;
}
export function sortByRankAndSuit(cards) {
    cards.sort(rankAndSuitSorter);
    updateCardOrder(cards);
    return cards;
}
export function sortByMeldsRankSuit(cards) {
    const collection = getCollection(cards);
    const sets = [].concat(...collection.sets);
    const runs = [].concat(...collection.runs);
    const deadwood = [].concat(...collection.deadwood);
    deadwood.sort(rankAndSuitSorter);
    const sortedCards = [].concat(sets, runs, deadwood);
    updateCardOrder(sortedCards);
    return sortedCards;
}
export function sortByOrder(cards) {
    cards.sort(orderSorter);
    updateCardOrder(cards);
    return cards;
}
export function updateCardOrder(cards) {
    //update order
    for (let i = 0; i < cards.length; i++) {
        const card = cards[i];
        card.order = i;
    }
    return;
}
export function getTopCardOfPile(pile) {
    const pileCopy = Array.from(pile);
    pileCopy.sort((l, r) => r.order - l.order);
    return pileCopy?.[0];
}
export function getCardsInPile(cards, pile) {
    const cardPile = cards.filter((c) => c.pile === pile);
    return cardPile.sort((l, r) => l.order - r.order);
}
//Can the sent card be added to a set?
export function cardMatchesSet(card, set) {
    return card.rank === set[0].rank;
}
//Can the sent card be added to a run?
export function cardMatchesRun(card, run) {
    if (card.suit !== run[0].suit) {
        return false;
    }
    const sortedRun = sortBySuitAndRank(Array.from(run)); //ensure we're sorted to make this easier
    const sentRank = getRankValue(card.rank);
    const firstRank = getRankValue(sortedRun[0].rank);
    const lastRank = getRankValue(sortedRun[sortedRun.length - 1].rank);
    return (sentRank === (firstRank - 1)) || (sentRank === (lastRank + 1));
}
export function addCardToPile(cards, card, toFrom) {
    const oldPile = card.pile;
    //update order of "to" pile
    const pileCards = getCardsInPile(cards, toFrom);
    sortByOrder(pileCards);
    //add to pile
    card.pile = toFrom;
    card.order = pileCards.length;
    card.isSelected = false;
    //update order of "from" pile
    const fromPile = getCardsInPile(cards, oldPile);
    sortByOrder(fromPile);
}
//# sourceMappingURL=data:application/json;base64,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